<template>
  <div class="userinfo" id="userInfoDiv">
    <el-col class="userinfoList"  style="width: 990px">
      <div class="prompt-info-wrap" v-if="userInfo.user_nature == '1'">
        <div class="prompt-info" v-if="lan=='ch'">1、参展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。</div>
        <div class="prompt-info" v-if="lan=='ch'">2、参展时，请使用谷歌浏览器打开展会官网，如需安装，<span class="download" @click="download"> {{language.down}} </span></div>
      </div>
      <div class="prompt-info-wrap" v-else>
        <div class="prompt-info" v-if="lan=='ch'">1、请点击“我要布展”，完善您的展位信息，以便应聘者与您对接。</div>
        <div class="prompt-info" v-if="lan=='ch'">2、参展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。</div>
        <div class="prompt-info" v-if="lan=='ch'">3、参展时，请使用谷歌浏览器打开展会官网，如需安装，<span class="download" @click="download"> {{language.down}} </span></div>
      </div>
      <!--个人-->
      <el-form v-if="userInfo.user_nature == '1'" :rules="personRules" :model="userInfos" ref="personMess">
        <div style="padding-left:50px;background-color: #FFFFFF;padding-top: 40px;padding-bottom: 50px;">
          <el-row class="itemRow" v-if="lan == 'ch'">
            <el-col :span="12" class="l-font head-portrait" style="line-height: 68px;">
              <span class="l-text-defaut w-107" style="float:left;">{{language.headPortrait}}:</span>
              <span class="l-text-gray" style="float:left;">
                <el-upload
                    :action="fileUpload"
                    class="uploadImgTx"
                    list-type="picture-card"
                    :on-success="updateSuccess"
                    :before-upload="onBeforeUpload"
                    :on-remove="handleRemove"
                    :on-preview="handlePictureCardPreview"
                    :limit="1"
                    v-model="userInfos.company_logo_url"
                    :file-list="imgList"
                    accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >
<!--                  <i slot="default" class="el-icon-plus" style="font-size: 40px;position: relative;top:-20px;"></i>-->
                  <img src="../../../assets/img/23.png" style="width: 100%; height: 100%;">
                </el-upload>
              </span>
              <span style="color:#ed6c00;float:left;padding-left: 10px;">使用真实头像更容易得到企业的青睐</span>
            </el-col>
          </el-row>
          <el-form-item class="person-form" prop="true_name" :label="language.trueName + ':'">
            <el-input class="l-text-gray" type="text" v-model="userInfos.true_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item class="person-form"
                        style="margin-left: 184px;"
                        :label="language.gender + ':'">
            <el-select
                class="l-text-gray"
                v-model="gender1"
                autocomplete="off"
                style="width: 510px;"
                :placeholder="language.chooseSex">
              <el-option v-for="item in gender" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="person-form ageError" prop="age" :label="language.age + ':'" style="margin-left: 171px;">
            <el-input class="l-text-gray" type="text" v-model.number="userInfos.age" maxLength="2" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item class="person-form" prop="location" :label="language.home + ':'" >
            <el-input class="l-text-gray" type="text" v-model="userInfos.location" v-on:click.native="showArea" :readonly="true" autocomplete="off"></el-input>
            <i :class="areaVisible ?'el-icon-arrow-up' : 'el-icon-arrow-down'" style="width: 20px;height: 20px; position: relative;left: -24px;font-size: 14px;color: #C0C4CC"></i>
          </el-form-item>
          <el-form-item class="person-form" :label="language.school + ':'" style="margin-left: 151px;">
            <el-input class="l-text-gray" type="text" v-model="userInfos.school" autocomplete="off" :placeholder="language.schoolTips"></el-input>
          </el-form-item>
          <el-form-item class="person-form" :label="language.highestEducation + ':'" style="margin-left: 151px;">
                <el-select
                  v-model="userInfos.education_id"
                  autocomplete="off"
                  class="l-text-gray"
                  style="width: 510px;"
                  :placeholder="language.educationTips1">
                  <el-option
                      v-for="item in this.educationList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"></el-option>
                </el-select>
          </el-form-item>
          <el-form-item class="person-form" prop="start_job_date" :label="language.workExperience + ':'">
                <el-select
                    v-model="userInfos.start_job_date"
                    style="width: 510px"
                    class="l-text-gray"
                    :placeholder="language.experienceList1">
                  <el-option :value="item" v-for="item in experienceList"></el-option>
                </el-select>
          </el-form-item>
          <!--上传学生证明-->
<!--          <el-row class="itemRow" v-if="this.userInfos.start_job_date == '应届毕业生'" prop="student_certificate">-->
<!--            <el-col :span="12" class="l-font">-->
          <el-form-item style="position: relative;" class="itemRow person-form studentZm" prop="student_certificate" :label="language.upStudentProve + ':'" v-if="this.userInfos.start_job_date == '应届毕业生'" >
<!--              <span class="l-text-defaut w-107" style="padding-top:2px;float: left">{{language.upStudentProve}}:</span>-->
              <span class="l-text-gray" style="float: left;">
                  <el-upload
                      ref="studentFileUpload"
                      :action="fileUpload"
                      class="uploadResume"
                      style="overflow: hidden;width: 120px;"
                      list-type="picture-card"
                      :on-success="updateSuccessSD"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemoveSD"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      :file-list="imgList4"
                      v-model="userInfos.student_certificate"
                      accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >

                    <i slot="default" class="el-icon-plus" style="position: absolute;left: 25px;top:45px;font-size: 70px;"></i>
                    <div class="upText" style="line-height: 20px;position: relative;top:40px;left: 0px;color: #777777;">
                      <span>{{language.click}}</span>
                      <span>{{language.upStudentProve1}}</span>
                    </div>
                </el-upload>
                <!-- <div class="deleteResume" @click="deleteFile('resume_file')">
                    <span style="color: #FFFFFF;font-weight: bold;font-size: 20px;cursor: pointer;"
                          >删除</span>
                </div> -->
              </span>
              <div
                  style="font-size:14px;color:#424242;padding-right:150px;margin-bottom: 20px;
                  float: right;padding-top: 69px;text-align: left;width: 130px;color: #777777;margin-right: 345px;"
              ><div style="height: 20px;">{{language.studentProveTips1}}</div>
                <div style="height: 20px;">{{language.studentProveTips2}}</div>
              </div>
          </el-form-item>
          <div style="width: 460px;position:relative;left: 230px;top:-1px;padding:10px 40px 10px 10px;margin-bottom: 20px;background:#fdfbf6;display: flex;" v-if="this.userInfos.start_job_date == '应届毕业生'">
            <div style="color: #f1831c;">提示：</div>
            <div style="flex: 9;color: #f58a25;">请您真实、准确、完整、有效填写应聘者信息，
            并上传真实学生证明，如在个人信息录入过程中采取欺骗、造假等手段，一经发现，个人将承担全部法律责任和后果。</div></div>
<!--            </el-col>-->
<!--          </el-row>-->
          <el-form-item class="person-form ageError" prop="email" :label="language.email + ':'" style="margin-left: 171px;">
            <el-input class="l-text-gray" type="text" v-model="userInfos.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item class="person-form phoneError" prop="tel_phone" :label="language.phone + ':'" style="margin-left: 154px;">
              <el-input class="l-text-gray" type="text" v-model="userInfos.tel_phone" autocomplete="off" style="width: 420px !important;" readonly="readonly"></el-input>
              <el-button typeof="primary" style="margin-left: 20px;background-color: #0071fd;color: #FFFFFF" @click="chancePhoneBtn">修改</el-button>
          </el-form-item>

<!--          <el-row class="itemRow">-->
<!--            <el-col :span="12" class="l-font">-->
              <el-form-item class="itemRow person-form studentZm" prop="resume_file" :label="language.upResume + ':'" >
<!--              <span class="l-text-defaut w-107" style="padding-top:2px;float: left">{{language.upResume}}:</span>-->
              <span class="l-text-gray" style="float: left;">
                  <el-upload
                      ref="jlFileUpload"
                      :action="fileUpload"
                      class="uploadResume"
                      style="overflow: hidden;width: 120px;"
                      list-type="picture-card"
                      :on-success="updateSuccessJL"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemoveJL"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      :file-list="imgList3"
                      v-model="userInfos.resume_file"
                      accept=".jpg, .pdf"
                  >

                    <i slot="default" class="el-icon-plus" style="position: absolute;left: 25px;top:45px;font-size: 70px;"></i>
                    <div slot="file" slot-scope="{file}" v-if="userInfos.resume_file">
                      <img
                        class="el-upload-list__item-thumbnail"
                        style="position: absolute;top: 50%;left: 0px;transform: translateY(-50%);height: auto;max-height: 100%;"
                        :onerror="defaultImg"
                        :src="userInfos.resume_file?userInfos.resume_file:'aa'" alt=""
                      >
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="handlePictureCardPreview(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                          class="el-upload-list__item-delete"
                          @click="handleRemoveJL(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                    <div class="upText" style="line-height: 20px;position: relative;top:40px;left: 0px;color: #777777;">
                      <span>{{language.click}}</span>
                      <span>{{language.upResume}}</span>
                    </div>
                </el-upload>
                <!-- <div class="deleteResume" @click="deleteFile('resume_file')">
                    <span style="color: #FFFFFF;font-weight: bold;font-size: 20px;cursor: pointer;"
                          >删除</span>
                </div> -->
              </span>
              <div
                  style="font-size:14px;color:#424242;padding-right:150px;
                  float: right;padding-top: 69px;text-align: left;width: 130px;color: #777777;margin-right: 345px;"
              ><div style="height: 20px;">{{language.suggestSize1}}</div>
                <div style="height: 20px;">{{language.suggestSize2}}</div>
              </div>
              </el-form-item>
<!--            </el-col>-->
<!--          </el-row>-->

          <!--个人简介-->
          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
              <span class="l-text-defaut w-107" style="padding-top:2px;">{{language.IntroductionPerson}}:</span>
              <span class="l-text-gray">
                <el-input type="textarea" v-model="userInfos.company_desc"
                          autocomplete="off" style="background: #f4f5f6;border-radius: 5px;"
                          rows = "4" :placeholder="language.IntroductionTips"></el-input>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
              <span class="l-text-defaut w-107" style="padding-top:2px;">{{language.hiddenMessage}}</span>
              <span class="l-text-gray">
                <el-radio v-model="userInfos.resume_show" @change="changeHidden" label="0">公开</el-radio>
                <el-radio v-model="userInfos.resume_show" @change="changeHidden" label="1">不公开</el-radio>
              </span>
              <div style="color: #777777;padding-left: 233px;padding-top: 15px;font-size: 15px;" v-if="hiddenCh == 0">所有招聘企业可见可查。</div>
              <div style="color: #777777;padding-left: 233px;font-size: 15px;padding-top: 15px;" v-else>仅投递简历企业可见可查。</div>
            </el-col>
          </el-row>

          <el-row style="text-align: center;padding-right: 50px;">
            <el-tooltip class="item" effect="dark" :content="language.saveInfonotes" placement="top">
              <el-button class="saveBtn" style="height: 50px !important;" type="primary" @click.native="ok">{{language.save}}</el-button>
            </el-tooltip>
          <el-button class="saveBtn" style="margin-left: 80px;border: 1px solid #409dfe; color: #0b8afd;" @click="showResume">{{language.examineResume}}</el-button>
          </el-row>
        </div>
      </el-form>

      <!--企业-->
      <el-form v-else label-width="100px" class="demo-ruleForm">
        <div class="userinfo-top">
          <!-- <el-row class="itemRow-new">
                   <el-col :span="12" class="l-font">
                     <div class="top-div">
                       <span class="w-top-107-new">{{language.accountId}}:</span>
                       <span style="color: #fff;">{{userInfos.user}}</span>
                     </div>
                   </el-col>
                 </el-row> -->
          <el-row class="itemRow-new">
            <el-col :span="12" class="l-font">
              <div class="top-div">
                <span class="w-top-107-new" style="width: 80px;">{{language.mobilePhone}}:</span>
                <span style="color: #fff;">{{userInfos.tel}}</span>
              </div>
            </el-col>
          </el-row>
<!--          <el-row class="itemRow-new">-->
<!--            <el-col :span="12" class="l-font">-->
<!--              <div class="top-div">-->
<!--                <span class="w-top-107-new">{{language.email}}:</span>-->
<!--                <span style="color: #fff;">{{userInfos.email}}</span>-->
<!--                &lt;!&ndash; <span class="l-text-gray"><el-input type="text" v-model="userInfos.email" autocomplete="off"></el-input></span> &ndash;&gt;-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <el-row class="itemRow-new" v-if="userInfo.superioruser_id==0">
            <el-col :span="12" class="l-font">
              <div class="top-div">
                <span class="w-top-107-new">{{language.balance}}:</span>
                <span style="color: #fff;font-size: 36px;">{{user_balance}}</span>
              </div>
              <el-button
                  type="warning"
                  class="btn-join"
                  @click="goRecharge"
                  style="background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));border: none;cursor: pointer;margin-left: 0px;line-height: 6px;    border: 1px solid rgb(236, 141, 55);"
              >{{language.recharge}}</el-button>
              <el-button style="background: transparent;color: #FFFFFF;border:1px solid #FFFFFF;margin-left: 10px;line-height: 6px;"
                          @click="yunqian">{{language.goYQ}}</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="com-userinfo" style="padding-left:28px;padding-right:28px;background-color: #FFFFFF;padding-top: 30px;padding-bottom: 50px;">
          <div class="audit" v-if="perfectMess">您的公司信息还未完善，请先完善信息。
            <span style="color: #0071FF;margin-left: 10px;cursor: pointer;"
                  @click="redactPop">
                立即完善</span></div>
          <div class="audit" v-if="!perfectMess && userInfos.check_status==0">您的公司信息尚未审核完成，请耐心等待。</div>
          <div class="audit" v-if="!perfectMess && userInfos.check_status==2">您的公司信息审核失败，原因：{{userInfos.check_explain}}</div>

<!--          <el-row class="itemRow" v-if="lan == 'ch'">-->
<!--            <el-col :span="12" class="l-font">-->
<!--              <span class="l-text-defaut w-107">{{language.headPortrait}}:</span>-->
<!--              <span class="l-text-gray" style="position: relative;top: 22px;"><img src="../../../assets/img/头像.png"></span>-->
<!--              <span style="color:#ed6c00;padding-left: 10px;">使用真实头像更容易得到企业的青睐</span>-->
<!--            </el-col>-->
<!--          </el-row>-->

          <!-- <el-form :model="userInfos" :rules="mesVerification" ref="ruleForm" label-width="100px" class="demo-ruleForm"> -->
          <el-row class="itemRow" v-if="lan == 'ch'" >
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107" hide-required-asterisk = false>{{language.guestscompanyName}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.guestscompanyName + ':'" prop="company">
                  {{userInfos.company}}
                </el-form-item>
              </span>
              <!--<span class="l-text-gray"><el-input type="text" v-model="userInfos.company" autocomplete="off"></el-input></span>-->
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="lan == 'ch'" >
            <el-col :span="12" class="l-font">
              <span class="l-text-gray">
                <el-form-item  :label="language.companyProperty + ':'" prop="companyProperty">
                  {{comNature}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.home}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.home + ':'" prop="location">
                  {{userInfos.location}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="lan == 'ch'" >
            <el-col :span="12" class="l-font">
              <span class="l-text-gray">
                <el-form-item  :label="language.email3 + ':'">
                  <span></span>
                  {{userInfos.superioruser_id != 0 ? userInfos.super_email : userInfos.email}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="lan == 'ch'" style="min-height: 50px;">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.creditCode}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.creditCode + ':'" prop="credit_code">
                  {{userInfos.credit_code}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>

          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107" style="padding-top:2px;float: left">{{language.businessLicense}}:</span>-->
              <span class="l-text-gray" style="float: left">
                <el-form-item  :label="language.businessLicense + ':'" prop="business_license" style="position: relative;">
                  <el-upload
                      :action="fileUpload"
                      :disabled="true"
                      class="uploadImg enterprise-logo"
                      list-type="picture-card"
                      :on-success="updateSuccess"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemove"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      v-model="userInfos.business_license"
                      :file-list="imgList2"
                      accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >
<!--                  <i slot="default" class="el-icon-plus" style="font-size: 40px;"></i>-->
<!--                    <img v-if="userInfo.business_license == null || this.userInfos.business_license == ''" src="../../../assets/img/wuYingYe.png" style="width: 70%;">-->
                  </el-upload>
                  <div v-if="userInfo.business_license == null || this.userInfos.business_license == ''"
                      style="width: 128px; height: 128px;background: #f1f1f1;text-align: center;border-radius: 5px;position: absolute;left: 121px;top: 0;">
                    <img  src="../../../assets/img/wuYingYe.png" style="width: 65%;margin-top: 17px;">
                  </div>
                </el-form-item>
              </span>
              <div
                  style="font-size:14px;color:#424242;padding-right:330px;
                  float: right;padding-top: 130px;text-align: left;width: 130px;color: #777777;">
<!--                <div>{{language.suggestSize1}}</div>-->
<!--                <div>{{language.suggestSize2}}</div>-->
              </div>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="userInfos.superioruser_id != 0">
            <el-col :span="12" class="l-font">
              <!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.username}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.companyMess + language.username + ':'">
                  {{userInfos.super_true_name}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="userInfos.superioruser_id != 0">
            <el-col :span="12" class="l-font">
              <!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.username}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.companyMess + language.userPost + ':'">
                  {{userInfos.super_user_post}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="userInfos.superioruser_id != 0">
            <el-col :span="12" class="l-font">
              <!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.username}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.companyMess + language.mobilePhone + ':'">
                  {{userInfos.super_tel}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="lan == 'ch'">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.username}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.contactPeople + language.username + ':'" prop="true_name">
                  {{userInfos.true_name}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.userPost}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.contactPeople + language.userPost + ':'" prop="user_post">
                  {{userInfos.user_post}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow" v-if="lan == 'ch'">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.contactPeople + language.phone + ':'}}:</span>-->
              <span class="l-text-gray" >
                <el-form-item v-model="userInfo.tel"  :label="language.contactPeople + language.phone + ':'" prop="tel">
                  {{userInfos.tel}}
                  <el-button typeof="primary" style="margin-left: 20px; background-color: #0071fd;color: #FFFFFF;line-height: 6px;"
                            @click="change">更换</el-button>
                </el-form-item>
              </span>
            </el-col>
          </el-row>

          <el-row class="itemRow" style="min-height: 50px;">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107">{{language.Introduction}}:</span>-->
              <span class="l-text-gray">
                <el-form-item  :label="language.Introduction + ':'" prop="company_desc">
                  <div style="width: 760px;word-wrap: break-word;word-break: break-all;">{{userInfos.company_desc}}</div>
                </el-form-item>
              </span>
            </el-col>
          </el-row>
          <el-row class="itemRow">
            <el-col :span="12" class="l-font">
<!--              <span class="l-text-defaut w-107" style="padding-top:2px;float: left">{{language.Logo}}:</span>-->
              <span class="l-text-gray" style="float: left">
                <el-form-item  :label="language.Logo + ':'" prop="company_logo_url">
                  <el-upload
                      :action="fileUpload"
                      class="uploadImg enterprise-logo"
                      list-type="picture-card"
                      :disabled="true"
                      :on-success="updateSuccess"
                      :before-upload="onBeforeUpload"
                      :on-remove="handleRemove"
                      :on-preview="handlePictureCardPreview"
                      :limit="1"
                      v-model="userInfos.company_logo_url"
                      :file-list="imgList"
                      accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
                  >
<!--                  <i slot="default" class="el-icon-plus" style="font-size: 40px;"></i>-->
<!--                    <img v-if="userInfos.company_logo_url == null || userInfos.company_logo_url == ''" src="../../../assets/img/wuLogo.png" style="width: 115%;">-->
                </el-upload>
                  <div v-if="userInfo.company_logo_url == null || this.userInfos.company_logo_url == ''"
                       style="width: 128px; height: 128px;background: #f1f1f1;text-align: center;border-radius: 5px;position: absolute;left: 121px;top: 0;">
                    <img  src="../../../assets/img/wuLogo.png" style="width: 110%;margin-top: 6px;margin-left: -7px;">
                  </div>
                </el-form-item>
              </span>
              <div
                  style="font-size:14px;color:#424242;padding-right:330px;
                  float: right;padding-top: 130px;text-align: left;width: 130px;color: #777777;">
<!--                <div>{{language.suggestSize1}}</div>-->
<!--                <div>{{language.suggestSize3}}</div>-->
              </div>
            </el-col>
          </el-row>
          <!-- </el-form> -->
          <el-row style="margin-top: 15px;text-align: center;">
            <el-tooltip class="item" effect="dark" :content="language.saveInfonotes" placement="top">
              <el-button class="saveBtn"
                         type="primary" @click.native="redactPop">{{language.goRedact}}</el-button>
            </el-tooltip>
          </el-row>
        </div>

      </el-form>
    </el-col>
    <receiveMsg />
    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="previewUrl" alt />
    </el-dialog>

    <!--修改手机号 个人-->
    <el-dialog
        title=""
        class="telPop"
        :visible.sync="chanceTel"
        width="800px"
        top="25vh"
        style="margin: 0 auto;text-align:center;z-index: 2000;border-radius: 10px;"
    >
      <div class="telPop-div">
        <div class="telPop-title">修改注册手机号</div>
        <hr>
        <div style="text-align: left;margin:15px 0;font-size: 16px;color: #373737;font-size: 18px;">个人用户修改手机号码可以通过以下方式联系我们：</div>
        <div class="linkman">
          <div class="linkman-left"><img src="../../../assets/img/17.png"></div>
          <div class="linkman-right">
            <div class="linkman-mes">{{language.contactPeople}}：张琦</div>
            <div class="linkman-mes">{{language.hintContact}}：15840690267</div>
            <div class="linkman-mes">{{language.contactEmail}}：1780821931@qq.com</div>
          </div>
        </div>
        <div class="linkman">
          <div class="linkman-left"><img src="../../../assets/img/17.png"></div>
          <div class="linkman-right">
            <div class="linkman-mes">{{language.contactPeople}}：于瑶</div>
            <div class="linkman-mes">{{language.hintContact}}：13664211428</div>
            <div class="linkman-mes">{{language.contactEmail}}：1120267113@qq.com</div>
          </div>
        </div>
      </div>

    </el-dialog>
    <!--修改手机号 企业-->
    <el-dialog
        title=""
        class="telPop"
        :visible.sync="chanceTelCom"
        width="550px"
        top="16vh"
        style="margin: 0 auto;text-align:center;z-index: 2000;border-radius: 10px;"
    >
      <div class="telPop-div-com telPop-qy">
        <div class="telPop-title">修改注册手机号</div>
        <hr style="width: 490px;float: left;margin-bottom: 20px;">
        <div class="xiugai">
          <el-form
              :model="changePhone"
              :rules="accountRules"
              ref="newTel"
          >
            <el-form-item class="new-tel" prop="user">
              <span>新手机号：</span>
              <el-input v-model="changePhone.user" placeholder="请输入新手机号"></el-input>
            </el-form-item>
            <el-form-item class="code-name" prop="code">
              <span style="margin-left: 16px;">验证码：</span>
              <el-input v-model="changePhone.code" placeholder=""></el-input>
              <el-button
                  style="background: #2b6ff9;color: #FFFFFF;border-radius: 5px;position: relative;left: -21px;width: 110px;"
                  @click="getCode">{{btnFindName}}</el-button>
            </el-form-item>
            <el-form-item style="margin-top: 60px;padding-left: 90px;">
              <el-button
                  style="background: #f47900;color: #FFFFFF;
                         border-radius: 4px;width: 140px;height: 50px;font-size: 22px;"
                  @click="submit"
              >提交</el-button>
              <el-button
                  style="background: #d9d9d9;color: #333333;
                         border-radius: 4px;width: 140px;height: 50px;font-size: 22px;margin-left: 30px;"
                  @click="cancel"
              >取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </el-dialog>

    <edit-user-info ref="editUserInfo" @userSaveEvent="userSaveEvent" @editSave="editSave"></edit-user-info>
    <area-div v-model="areaName" :areaEl="areaEl" :visible.sync="areaVisible" @areaVisibleEvent="areaVisibleEvent" parentId="userInfoDiv"/>
  </div>
</template>
<script>
import reqest from "@/common/reqest";
import {getLanguage, language} from "../../../language/get";
import {getUserInfo, updateUserInfo, getUserBalance, updateTel,delUserFile} from "../../../api/user";
import store from "../../../store";
import Cookie from "../../../common/cookie"
import receiveMsg from '../../../components/receiveMsg'
import {selectEducation } from "../../../api/exhibition";
import areaDiv from "@/components/area/index";
import {mapGetters} from "vuex";
import {goCloudPay} from "@/api/order";
import {retPwdNum} from "@/api/login";

import editUserInfo from "@/pages/user/userinfo/editUserInfo";
import {isEmail, isPhone1} from "@/common/validate";

export default {
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  data() {
    let Lan = getLanguage('ch');
    return {
      last_company_logo_url:null,
      last_student_certificate:null,
      last_resume_file:null,
      last_business_license:null,
      changePhone:{
        user:"",
        code:""
      },
      comNature:null,
      hiddenCh:0,
      defaultImg: 'this.src="' + require('@/assets/ic_enclosure.png') + '"',
      experienceList:['应届毕业生','1年以下','1-2年','2-3年','3-4年','4-5年','5年以上'],
      areaVisible: false,
      areaName: '',
      areaEl: null,
      perfectMess: null,
      educationList:null, // 最高学历列表
      showImage:null, //上传简历后显示的图片
      ruleForm: {
        name: '',
      },
      //个人表单验证
      personRules: {
        true_name: [
          {
            required: true,
            message: language().trueNameRules,
            trigger: "blur",
            max: 50
          }
        ],
        age: [{ required: true, message: language().ageRules, trigger: "blur" }],
        location: [
          { required: true, message: language().homeRules1, trigger: "change", max: 100 }
        ],
        start_job_date: [{ required: true, message: language().workExRules,  trigger: "blur" }],
        email: [{ required: true, message: language().emailRules, validator: this.emailValidator, trigger: "blur" }],
        tel_phone: [{ required: true, message: language().phoneRules, validator: this.phoneValidator, trigger: "blur" }],
        student_certificate: [{ required: true, message: language().studentRules,  trigger: "blur" }],
        resume_file: [{ required: true, message: language().jlRules,  trigger: "blur" }]
      },
      rules: {
        name: [
          {required: true, message: '请输入活动名称', trigger: 'blur'},
          {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ]
      },
      accountRules: {
        user: [
          { required: true, message: language().phoneRules, trigger: "blur" },
        ],
        code: [{ required: true,validator: this.checkLoginCode, trigger: "blur" }]
      },

      fileUpload: reqest.apiUrl+'/Home/Publicother/uplodadLogo',
      language: language(),
      user_balance: 0,
      userInfos: {
        location:"",
        true_name:"",
        name:"",
        check_status: null,
      },
      imgList: [],
      imgList2: [],
      imgList3: [],
      imgList4: [],
      fileList:[],
      previewUrl: '',
      dialogVisible: false,
      lan: Cookie.get("lang"),
      hiddenMes: '1',
      chanceTel: false,
      chanceTelCom:false,
      redactVerify: false,
      codeFlag:0,
      btnFindName: language().sendVerificationCode,
      finTimer: null,
      gender:[{
        value: 1,
        label:language().man
      },{
        value:2,
        label:language().woman
      }],
      gender1:"",
      educationHest:"",
      //token:this.userInfos.token
      mesVerification:{
        location:[
          {
            required:true,
            message:"请输入所在城市",
            trigger:"blur"
          }
        ],
        credit_code:[
          {
            required:true,
            message:"请输入统一社会信用代码",
            trigger:"blur"
          }
        ],
        tel:[
          {
            required:true,
            message:"请输入手机号",
            trigger:"blur"
          }
        ],
        company_desc:[
          {
        required:true,
        message:"请输入公司简介",
        trigger:"blur"
          }
        ],
        company_logo_url:[
          {
            required:true,
            message:"请选择logo",
            trigger:"blur"
          }
        ],
        business_license:[
          {
            required:true,
            message:"请选择营业执照",
            trigger:"blur"
          }
        ],
      }
    };
  },
  components:{
    editUserInfo,
    receiveMsg,
    areaDiv
  },
  created() {
    //this.userInfo();

    /*this.userInfos = this.$store.state.user.userInfo
    if(this.userInfos.company_logo_url){
      this.imgList = [{ status: "success", url: this.userInfos.company_logo_url }];
    }else{
      this.imgList = [];
    }*/
  },
  mounted() {
    this.userInfot();
    this.getUserBalanceInfo();
    selectEducation().then((res) =>{
          if(res.type == 1){
            const data = res.data;
            this.educationList = data;
            // console.log("1", this.educationList);
          }
    });
    },
  methods: {
    delUserFileFun(arr){
      delUserFile({ urls: arr }).then((res) => {
        //提示处理

      });
    },
    phoneValidator(rule, value, callback){
      // if(this.userInfo.user_nature == 1){
        isPhone1(rule, value, callback);
      // }else{
      //   callback();
      // }
    },
    emailValidator(rule, value, callback){
      // if(this.userInfo.register_area == 2){
      isEmail(rule, value, callback);
      // }else{
      //   callback();
      // }
    },
    changeHidden(e){
      if(e == '0') {
        this.hiddenCh = 0;
      }else{
        this.hiddenCh = 1;
      }
    },
    userSaveEvent(uinfo){
      this.userInfos = uinfo;
      this.userInfot();
      // console.log("更信后的信息数据==" , this.userInfos);
    },
    //保存个人信息
    editSave(val,info){
      let arr = [];
      if(val) {
        if(this.last_company_logo_url != info.company_logo_url){
          arr.push(this.last_company_logo_url);
        };
        if(this.last_business_license != info.business_license){
          arr.push(this.last_business_license);
        }
        if(arr.length > 0) {
          this.delUserFileFun(arr);
        }

      }
    },
    //点击获取验证码
    getCode() {
      let promise = [];
      this.codeFlag = 1;
      // console.log("this.codeFlag= " + this.codeFlag);
      promise.push(this.$refs.newTel.validate());
      Promise.all(promise).then(() => {
        //请求
        let timeCount = 60;
        if (!this.finTimer) {
          this.btnFindName = timeCount + "s";
          const height = document.body.clientHeight / 2;
          retPwdNum({ tel: this.changePhone.user }).then((res) => {
            if (res.type != 1) {
              if (this.lan == "ch") {
                this.$message.error({ message: res.text, offset: height });
              } else {
                return this.$message.error({
                  message: res.text_en,
                  offset: height,
                });
              }
            }
          });
          this.finTimer = setInterval(() => {
            if (timeCount === 0) {
              this.btnFindName = this.language.toResend;
              clearInterval(this.finTimer);
              this.finTimer = null;
            } else {
              timeCount--;
              this.btnFindName = timeCount + "s";
            }
          }, 1000);
        }
      });

    },
    //提交
    submit() {
      let promise = [];
      console.log("新手机号： " + this.changePhone.user + " " +this.changePhone.code + " " + this.userInfo.user_id);
      let data = {
        user_id:this.userInfo.user_id,
        tel:this.changePhone.user,
        code:this.changePhone.code
      };
      promise.push(this.$refs.newTel.validate());
      Promise.all(promise).then(() => {
        updateTel(data).then((res) => {
          const height = document.body.clientHeight / 2;
          if(res.type != 1) {
            this.$message.error({ message: res.text, offset: height });
          }else {
            this.$message.success({ message: res.text, offset: height });
            this.chanceTelCom = false;
          }

        });
      });

    },
    //取消
    cancel() {
      this.chanceTelCom = false;
    },
    //验证码 验证
    checkLoginCode(rule, value, callback){
      if (!value && this.codeFlag == 0) {  //js中页面跳转的方法
        console.log("value=" + value);
        callback(new Error(language().codeRules));
      }
      callback();
    },
    showResume(){
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // if(this.userInfos.resume_file){
      //   window.open(this.userInfos.resume_file);
        window.location.href = "user.html#/onlineResume"
      // }else{
      //   this.$message({
      //     showClose: true,
      //     message: "你还没有上传简历",
      //     type: "error",
      //     offset: "120"
      //   });
      // }

    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.userInfos.location = this.areaName;
    },
    showArea(e){
      this.areaName = this.userInfos.location;
      this.areaEl = e.target;
      this.areaVisible = true;
    },
    deleteFile(key){
      if(key == 'resume_file'){
        this.imgList3 = [];
        this.userInfos.resume_file = '';
      } else if(key == 'company_logo_url'){
        this.imgList = [];
        this.userInfos.company_logo_url = '';
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: '',
        key: Date.now()
      });
    },
    yunqian() {
      let porp = {
        user_id:this.userInfos.user_id
      }
      goCloudPay(porp).then((res)=> {
          let url = res.data;
          // console.log("22222444" , res.data);2
          window.open(url);
      });
    },
    goRecharge(){
      window.location.href = "rechargePage.html"
    },
    handlePictureCardPreview(file) {
      let url = file.url;
      if(url.indexOf('.pdf') > -1){
        window.open(file.url);
      }else{
        this.previewUrl = file.url;
        this.dialogVisible = true;
      }

    },
    handleRemove() {
      this.userInfos.company_logo_url = "";
    },
    handleRemoveJL() {
      this.userInfos.resume_file = "";
      this.$refs.jlFileUpload.clearFiles();
    },
    handleRemoveBL() {
      this.userInfos.business_license = "";
    },
    handleRemoveSD() {
      this.userInfos.student_certificate = "";
      this.$refs.studentFileUpload.clearFiles();
    },
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      const height = document.body.clientHeight / 2;
      if (!isLt1M) {
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: height
        });
      }

      return isLt1M;
    },
    chancePhoneBtn() {
      this.chanceTel = true;
    },
    change() {
      this.btnFindName = "获取验证码";
      clearInterval(this.finTimer);
      this.finTimer = null;
      this.changePhone.code = "";
      this.changePhone.user = "";
      this.chanceTelCom = true;
    },
    updateSuccess(res) {
      if (res.type == "1") {
        this.userInfos.company_logo_url = res.data.file.picurl;
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        // return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    updateSuccessBL(res) {
      if (res.type == "1") {
        this.userInfos.business_license = res.data.file.picurl;
        // console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        // return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    updateSuccessJL(res) {
      if (res.type == "1") {
        this.userInfos.resume_file = res.data.file.picurl;
        // console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        // return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    //学生证明
    updateSuccessSD(res){
      if (res.type == "1") {
        this.userInfos.student_certificate = res.data.file.picurl;
        // console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        // return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    userInfot() {
      let data = {
        token: this.$store.state.user.token
      };
      getUserInfo().then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          // return this.$message.error({message: res.text_en, offset: 120})
        }
          this.userInfos = res.data[0];

          // console.log("222222222222" , this.userInfos);
          if(this.userInfos.company_logo_url){
            this.imgList = [{ status: "success", url: this.userInfos.company_logo_url }];
            this.last_company_logo_url = this.userInfos.company_logo_url;
          }else{
            this.imgList = [];
          }
          if(this.userInfos.business_license){
            this.imgList2 = [{ status: "success", url: this.userInfos.business_license }];
            this.last_business_license = this.userInfos.business_license;
          }else{
            this.imgList2 = [];
          }
          if(this.userInfos.resume_file){
            this.imgList3 = [{ status: "success", url: this.userInfos.resume_file }];
            this.last_resume_file = this.userInfos.resume_file;
            // console.log("头像" , this.last_resume_file);
          }else{
            this.imgList3 = [];
          }
        if(this.userInfos.student_certificate){
          this.imgList4 = [{ status: "success", url: this.userInfos.student_certificate }];
          this.last_student_certificate = this.userInfos.student_certificate;
        }else{
          this.imgList4 = [];
        }

          for (var i = 0; i < this.gender.length; i++) {
            if(this.gender[i].value == this.userInfos.sex){
              this.gender1 = this.gender[i].value;
              break;
            }
          }
          //企业性质
        if(this.userInfos.super_nature == 0 || this.userInfos.nature == 0) {
          this.comNature = "国有企业";
        }else if(this.userInfos.super_nature == 1 || this.userInfos.nature == 1){
          this.comNature = "民营企业";
        }else if(this.userInfos.super_nature == 2 || this.userInfos.nature == 2){
          this.comNature = "合资企业";
        }else if(this.userInfos.super_nature == 3 || this.userInfos.nature == 3){
          this.comNature = "外资企业";
        }else if(this.userInfos.super_nature == 4 || this.userInfos.nature == 4){
          this.comNature = "个人独资企业";
        }else if(this.userInfos.super_nature == 5 || this.userInfos.nature == 5){
          this.comNature = "其他";
        }

        this.perfectMess = false;
        if(this.userInfos.company == null || this.userInfos.location == null || this.userInfos.credit_code == null ||
            this.userInfos.business_license == null || this.userInfos.true_name == null || this.userInfos.user_post == null ||
            this.userInfos.tel == null || this.userInfos.company_desc == null || this.userInfos.company_logo_url == null ||
            this.userInfos.company == "" || this.userInfos.location == "" || this.userInfos.credit_code == "" ||
            this.userInfos.business_license == "" || this.userInfos.true_name == "" || this.userInfos.user_post == "" ||
            this.userInfos.tel == "" || this.userInfos.company_desc == "" || this.userInfos.company_logo_url == "" || this.comNature == null){
          this.perfectMess = true;
        }

      });
    },
    getUserBalanceInfo() {

      let data = {
        user_id: this.$store.state.user.userInfo.user_id
      };
      getUserBalance(data).then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          // return this.$message.error({message: res.text_en, offset: 120})
        }
        this.user_balance = isNaN(res.data)?0:res.data;

      });
    },
    //企业信息  去编辑
    redactPop() {
      if(this.userInfo.superioruser_id != 0){
        const height = document.body.clientHeight / 2;
        this.$message.error({message:"子账号无法修改企业信息", offset:height})
      }else {
        this.$refs.editUserInfo.redactPop();
      }

    },
    //确认修改
    ok() {
        let arr = [];
        // console.log("信息==" + this.last_company_logo_url + " " + this.last_student_certificate + " " + this.last_resume_file);
        // console.log("arr== " , this.userInfos);
          if(this.last_company_logo_url != this.userInfos.company_logo_url){
            arr.push(this.last_company_logo_url);
          };
          if(this.last_student_certificate != this.userInfos.student_certificate){
            arr.push(this.last_student_certificate);
          };
          if(this.last_resume_file != this.userInfos.resume_file){
            arr.push(this.last_resume_file);
          }
      // console.log("arr== " , arr);
        this.editUserInfo();
        if(arr.length > 0) {
          this.delUserFileFun(arr);
        }


    },
    editUserInfo(){
      let promise = [];
      // console.log("性别==" + this.gender1);
      if(this.userInfos.start_job_date != "应届毕业生" ) {
        this.userInfos.student_certificate = null;
      };
      let data = {
        lan: this.lan,
        token:this.$store.state.user.token,
        company: this.userInfos.company,
        location: this.userInfos.location,
        true_name: this.userInfos.true_name,
        user_post: this.userInfos.user_post,
        tel_phone: this.userInfos.tel_phone,
        company_desc: this.userInfos.company_desc,
        credit_code: this.userInfos.credit_code,
        age: this.userInfos.age,
        sex: this.gender1,
        education_id: this.userInfos.education_id,
        resume_file: this.userInfos.resume_file,
        student_certificate: this.userInfos.student_certificate,
        email: this.userInfos.email,
        start_job_date: this.userInfos.start_job_date,
        resume_show: this.userInfos.resume_show,
        school: this.userInfos.school,
        company_logo_url: this.userInfos.company_logo_url,
        person_resume_url:this.userInfos.person_resume_url,   //简历路径
        business_license:this.userInfos.business_license  //营业执照路径
      };
      //console.log("营业执照：" + this.userInfos.business_license);
      //console.log("logo：" + this.userInfos.company_logo_url);
      if(this.userInfos.user_nature == '1'){
        // personMess
        promise.push(this.$refs.personMess.validate((valid) => {
          if(!valid) {
            console.log("信息填写不完全！");
            return false;
          }
          this.updateUserInfoFun(data);

        }));

      }else{
        promise.push(this.$refs.redactMes.validate((valid) => {
          if(!valid){
            console.log("信息填写不完全！");
            return false;
          }
          this.updateUserInfoFun(data);

        }));
      }


    },
    updateUserInfoFun(data){
      updateUserInfo(data, this).then(res => {
        const height = document.body.clientHeight / 2;
        this.$message({
            showClose: true,
            message: this.lan == 'ch' ? res.text : res.text_en,
            type: "success",
            offset: height
          });
          let dd = this.userInfos;
          for(let d in data){
             this.userInfos[d] = data[d];
          }
          // console.log("更新后数据==" , this.userInfos);
          this.last_student_certificate = this.userInfos.student_certificate;
          this.last_company_logo_url = this.userInfos.company_logo_url;
          this.last_resume_file = this.userInfos.resume_file;

          this.$store.commit("SET_USERINFO", this.userInfos);
          this.redactVerify = false;
           //this.$store.commit("SET_USERINFO", userDet);
        /*if (res.type == "1") {
          this.$message({
            showClose: true,
            message: this.language.editSuccess,
            type: "success",
            offset: "100"
          });
          this.$refs.dialogChild.receiveDialogFormVisible = false;
          this.onClear();
        } else {
          return this.$message.error({ message: res.text, offset: 120 });
        }*/
      })
      .catch(() => {});
    },
   //下载谷歌浏览器
     download() {
       window.open("https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds")
      }
  },

};
</script>
<style>
 .enterprise-logo .el-upload{
  display: none !important;
}
</style>
<style scoped>

.xiugai {
  clear: both;
  width: 500px;
  text-align: left;
  /*padding-left: 15px;*/

}
.new-tel >>> .el-input__inner {
  width: 390px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.code-name >>>  .el-input__inner {
  width: 270px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.xiugai span {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  text-align: right;
}
.xiugai {
  clear: both;
}
.xiugai >>> .el-form-item__error {
  position: relative;
  left: 85px;
  top: 5px;
}
.userinfo .userinfoList {
  border: none;
  /*height: 1166px;*/
  /*background: #ffffff;*/
  /*padding:30px 49px 40px 49px;*/
  /* padding-left: 150px !important; */
  box-sizing: border-box;
}
.userinfo-top{
  background: url('../../../assets/img/38.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 20px 0px 10px 40px;
  margin-bottom: 20px;
}
.top-div{
  min-width: 260px;
  /*border: 1px solid #fff;*/
  display: inline-block;
  padding: 5px 10px 5px 30px;
  border-radius: 10px;
  font-size: 22px;
  /* color: #fff !important; */
}
.itemRow-new{
  margin-bottom: 10px;
}
.itemRow {
  min-height: 50px;
}
.userinfo .itemRow {
  margin-bottom: 20px;
}
.w-107 {
  width: 220px;
  color: #424242;
  font-size: 16px;
  display: inline-block;
  /*overflow: hidden;*/
  text-overflow:ellipsis;
  white-space: nowrap;
  text-align: right;
  padding-right: 10px;
}
.w-top-107-new{
  width: 150px;
  color: #fff;
  font-size: 22px;
  display: inline-block;
}
.w-top-107 {
  width: 150px;
  color: #424242;
  font-size: 16px;
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
  .l-text-gray {
    color: #a1a1a1;
    font-size: 16px;
  }
.l-text-gray >>> .el-form-item__label{
  /* font-size: 16px !important;*/
  width: 220px !important;
  /*margin-right: 40px !important;*/
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
 }
.l-text-gray >>> .el-form-item__error{
  margin-left: 120px;
  margin-top: 2px;
  font-size: 14px;
}
  .l-text-gray >>> .el-input__inner{
    /*color: #56575a !important;*/
    /*background-color: #f4f5f6;*/
    /*width: 397px;*/
    height: 39px;
    background-color: #f5f6f7;
    border-radius: 5px;
    border: solid 1px #d9d9d9;
  }

  .l-text-gray >>> .el-textarea__inner{
    color: #56575a !important;
    background: #f4f5f6;
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 60%;
}
.el-col-12{
  width: 90%;
}
.saveBtn{
  /*margin-left:300px;*/
  width: 200px;
  font-size:22px;
}
.prompt-info-box{
  background:#fff;
  height:30px;
  padding:15px;
  width:960px;
  margin-left:200px;
}
.userinfo >>> .prompt-info-wrap{
  width: 940px;
  padding: 20px 20px 25px 30px;
  background: #FFFFFF;
  margin-bottom: 10px;
  border-radius: 5px;
  margin-top: 0px;
}
.userinfo >>> .prompt-info-wrap .prompt-info{
  height:30px;
  line-height:30px;
  background:#FFFFFF;
  color:#f47900;
  font-size:18px;
  padding-left: 0;
  font-weight:bold;
}

.userinfo >>>  .prompt-info span{
  color:#0071FF;
  cursor:pointer;
}
.userinfo >>> .el-textarea{
  width: 60% !important;
  font-size: inherit !important;
  vertical-align: top;
  margin-top: -2px;
}
</style>
<style>
.itemRow .el-upload{
   background: #F2F2F2;
   border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

}
.itemRow .el-upload .upText{
  font-size: 14px;
  color: #424242;
  line-height: normal;
}
.itemRow .uploadImg {
  display: flex;
  width: 160px;
  margin-left: 120px;
}
.itemRow ..itemRow .uploadImgTx {
  display: flex;
  /*width: 160px;*/
  /*margin-left: 120px;*/
}
.itemRow .uploadImgTx .el-upload {
border-radius: 66px;
}
.itemRow .uploadImgTx .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.itemRow .uploadImg .el-upload-list
.uploadResume .el-upload-list{
  margin-right: 20px;
  position: absolute;
  z-index: 999;
}
.uploadResume {
  display: flex;
  position: relative;
}
/*.itemRow .uploadResume .el-upload--picture-card {
  width: 120px !important;
  height: 120px !important;
}*/
.deleteResume {
  width: 120px;
  height: 120px;
  position: absolute;
  left: 400px;
  top:0px;
  border-radius: 5px;
  background: url("../../../assets/img/21.png") no-repeat;
  background-size: 120px 120px;
  text-align: center;
  padding-top: 45px;
  cursor: pointer;
}
.telPop .el-dialog__headerbtn  .el-icon-close {
  width: 20px !important;
  height: 20px !important;
  background: #0c6dce !important;
  color: #fff !important;
  border-radius: 50% !important;
  line-height: 20px !important;
}
.telPop-div {
  width: 700px;
  margin: 2px auto;
  /*border: 1px solid #333333;*/
}
.telPop-div-com {
  width: 500px;
  margin: 2px auto;
}
.telPop-qy {
 padding-left: 10px;
}
.telPop-title{
  text-align: left;
  font-size: 20px;
  color: #363636;
  font-weight: bold;
  margin-bottom: 10px;
}
/*.redact-div {*/
/*  width: 850px;*/
/*  margin: 2px auto;*/
/*}*/
.redact-centre {
  padding-top: 29px;
}
/*.redact-centre .el-form-item {*/
/*  margin-left: 40px;*/
/*}*/
.redact-centre .el-form-item__label{
  width: 160px !important;
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.redact-centre .el-input__inner {
  width: 380px;
  height: 39px;
  background-color: #f5f6f7;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
}
.redact-title {
  width: 160px;
  height: 24px;
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 6px;
  letter-spacing: 0px;
  color: #333333;
}
/*.redact-dialog .el-dialog {*/
/*  width: 40%;*/
/*}*/
/*.redact-dialog hr {*/
/*  width: 700px;*/
/*  margin: 10px 0;*/
/*  border: solid 1px #cccccc;*/
/* }*/
.redact-dialog .el-dialog__headerbtn  .el-icon-close {
  width: 20px !important;
  height: 20px !important;
  background: #0c6dce !important;
  color: #fff !important;
  border-radius: 50% !important;
  line-height: 20px !important;
}
.redact-dialog .el-upload--picture-card{
  width: 93px !important;
  height: 93px !important;
  background-color: #eff0f1;
}
.redact-dialog .uploadImg .el-upload-list {
  margin-right: 20px;
  position: absolute;
  z-index: 999;
}
.redact-dialog .el-upload-list__item-thumbnail,
.redact-dialog .el-upload-list--picture-card .el-upload-list__item{
  width: 93px !important;
  height: 93px !important;
}
.redact-dialog .deleteResume {
  width: 93px;
  height: 93px;
  position: absolute;
  left: 300px;
  border-radius: 5px;
  background: url("../../../assets/img/21.png") no-repeat;
  text-align: center;
  padding-top: 0px;
}
.redact-dialog .el-textarea__inner{
  background-color: #f5f6f7;
  color: #4d4d4d;
  width: 380px;
}
.redact-dialog .el-form-item__error {
  margin-left: 60px;
}
.linkman {
  display: flex;
  width: 700px;
  border: none;
  background: #e8f0fd;
  border-radius: 5px;
  margin-bottom: 20px;
}
.linkman-right {
  text-align: left;
  padding-top: 10px;
}
.linkman-left {
  margin: 20px 20px;
}
.linkman-mes {
  padding-top: 10px;
  color: #464849;
}
.audit {
  width: 975px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(255, 0, 0, 0.2);
  color: #ff0000;
  font-size: 18px;
  margin: 20px 0 5px;
  padding: 0 0 0 15px;
  position: relative;
  left: -28px;
  top: -30px;
}

.uploadResume .el-upload-list--picture-card .el-upload-list__item{
  width: 120px;
  height: 120px;
}
.uploadResume .el-upload--picture-card{
  width: 120px;
  height: 120px;
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item{
  width: 68px;
  height: 68px;
  position: absolute;
  z-index: 1;
}
.head-portrait .el-upload--picture-card{
  width: 68px;
  height: 68px;
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item-thumbnail{
  border-radius: 50%
}
.head-portrait .el-upload-list--picture-card .el-upload-list__item{
  border: 1px solid #ffffff;
}
.head-portrait .el-upload--picture-card i{
  top: 0px!important;
}
.head-portrait .uploadImg{
  margin-left: 0px;
  width: auto;
}
.demo-ruleForm .com-userinfo .el-row{
  margin-bottom: 0px;
}
.demo-ruleForm .com-userinfo .el-row span .el-form-item{
margin-bottom: 10px;
}
.person-form  {
  margin-left: 140px;
}
.person-form .el-form-item__label{
 font-size: 16px;
}
.person-form .el-form-item__content {
  width: 850px;
}
.person-form .el-form-item__error {
  margin-left: 96px;
  margin-top: 4px;
}
.ageError .el-form-item__error {
  margin-left: 63px;
  margin-top: 4px;
}
.phoneError .el-form-item__error {
  margin-left: 79px;
  margin-top: 4px;
}
</style>
